import React from 'react';
import getConfig from 'next/config';
import { NextPage } from 'next';

export default function withNextConfig<P>(Component: NextPage<P>): NextPage<Omit<P, 'config'>> {
  function WrappedComponent(props: P) {
    const config = getConfig();
    return (
      <Component
        {...props}
        config={config?.publicRuntimeConfig ?? {}}
      />
    );
  }

  if (Component.getInitialProps) {
    WrappedComponent.getInitialProps = Component.getInitialProps;
  }

  return WrappedComponent;
}
